const React = require("react");

function SortAscendingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
  }));
}

module.exports = SortAscendingIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/SortAscendingIcon.js
 ** module id = 613
 ** module chunks = 0
 **/